export const editChangeAccountInformation = (updateType, newClassName, newEmailAddress, newGradeLevel, 
        nbrPlayers, newAccountNbr ) =>{
    let message = "";
    let errorsFound = false;
    let newClassNameClass = "font-weight-bold";
    let newEmailAddressClass = "font-weight-bold";
    let newGradeLevelClass = "font-weight-bold";
    let nbrPlayersClass = "font-weight-bold";
    let newAccountNbrClass = "font-weight-bold";
    if (updateType === "accountProfile" || updateType === "createClass"){
       
        if (updateType === "accountProfile"){
            if ((!newClassName || newClassName === "") &&
                (!newEmailAddress || newEmailAddress === "")){
                    message = "Neither the className nor the emailAddress have been entered."
                    errorsFound = true;
                    newClassNameClass += " text-danger";
                    newEmailAddressClass += " text-danger";
            }
        }
        if (updateType === "createClass"){
            if ((!newClassName || newClassName === "") ||
            (!newEmailAddress || newEmailAddress === "")){
                message = "Both New Class Name and Email Address are required."
                errorsFound = true;
                newClassNameClass += " text-danger";
                newEmailAddressClass += " text-danger";
            }
            if (!newGradeLevel || newGradeLevel === "none"){
                message = "Grade Level selection required."
                errorsFound = true;
                newGradeLevelClass += " text-danger";
            }
            if (!nbrPlayers || isNaN(nbrPlayers) || nbrPlayers < 1){
                message = "Nbr Players required and must be greater than 0.";
                nbrPlayersClass += " text-danger";
            }
        }
        if (newClassName && newClassName !== ""){
            if (newClassName.length < 8){
                message = "New Class Name must be at least 8 characters long.";
                newClassNameClass += " text-danger";
                errorsFound = true;
            }
        }
        if (newEmailAddress && newEmailAddress !== ""){
            if (!newEmailAddress.includes("@") || newEmailAddress.length < 10){
                newEmailAddressClass += " text-danger";
                message = "Email address is not valid.";
                errorsFound = true;
            }   
        }
    }
    if (updateType === "changeDefault"){
        if (newAccountNbr === "" || newAccountNbr === "none"){
            newAccountNbrClass += " text-danger";
            message = "New Class Code is required.";
            errorsFound = true;
        }
    }
    const errorObj = {errorsFound: errorsFound, message: message, newClassNameClass: newClassNameClass,
        newEmailAddressClass: newEmailAddressClass, newGradeLevelClass: newGradeLevelClass,
        nbrPlayersClass: nbrPlayersClass, newAccountNbrClass: newAccountNbrClass
    }
    return errorObj;
}
export default editChangeAccountInformation;